import { z } from 'zod';

export const UserSchema = z.object({
    id: z.number().int().positive(),
    handle: z.string().min(1),
    // Null for accounts created from a shared invite link.
    email: z.string().nullable(),
    isAdmin: z.boolean(),
    createdAt: z.coerce.date(),
});

export type User = z.infer<typeof UserSchema>;

export const SessionSchema = z.object({
    id: z.number().int().positive(),
    handle: z.string().min(1),
    isAdmin: z.boolean(),
});

export type Session = z.infer<typeof SessionSchema>;

// HandleSchema and PinSchema live in auth.schema.ts, beside the flows that use
// them.
